(function() {
    const $doc = $(document);

    $doc.on('click', '.prtc_link_recover_customer_password', showRecoverCustomerPassword);
    $doc.on('click', '.prtc_close_recover_customer_password_btn', closeRecoverCustomerPassword);
})();

/**
 * パスワード復旧スクリーンを表示する
 * @param e
 */
function showRecoverCustomerPassword(e) {
    if (e) {
        e.preventDefault();
    }
    $('#prtcRecoverCustomerPasswordForm').fadeIn(600);
    $('.prtc_recover_customer_password_form').removeClass('hidden').addClass('shown');
}

/**
 * パスワード復旧スクリーンを閉じる
 * @param e
 */
function closeRecoverCustomerPassword(e) {
    if (e) {
        e.preventDefault();
    }

    $('.prtc_recover_customer_password_form').removeClass('shown').addClass('hidden');
    $('#prtcRecoverCustomerPasswordForm').fadeOut(600);
}
